import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component } from '@angular/core';

@Component({
  providers: [provideTranslocoScope('orders')],
  selector: 'ord-orders',
  imports: [TranslocoPipe, ],
  templateUrl: './orders.html',
  styleUrl: './orders.scss',
})
export class Orders {

}
